@if (data?.icon) {
  <div class="text-center pb-2">
    <i class="das {{ data.icon }}" [ngClass]="iconSize"></i>
  </div>
}
@if (data?.title || data?.reasonTitle) {
  <div>
    @if (data?.title) {
      <h2 mat-dialog-title class="text-black fs-3 text-center">
        <b>{{ data.title }}</b>
      </h2>
    }
    @if (data?.reasonTitle) {
      <h2 mat-dialog-title class="text-black fs-3">
        <b>{{ data.reasonTitle }}</b>
      </h2>
    }
  </div>
}
@if (data?.description || data?.reasonLabel) {
  <mat-dialog-content class="text-center">
    @if (data?.allowHtml) {
      <p class="fs-14 text-black pt-2 pb-3" [innerHTML]="data.description"></p>
    }
    @if (!data?.allowHtml) {
      <p class="fs-14 text-black pt-2 pb-3">{{ data.description }}</p>
    }
    @if (data?.reasonLabel) {
      <div class="remark-container">
        <label for="remarks" class="text-muted fs-14 d-block text-start fw-medium"
          >{{ data.reasonLabel }}<sup class="text-danger fs-120">*</sup></label
        >
        <textarea id="remarks" class="remark-input" [(ngModel)]="reason"></textarea>
      </div>
    }
  </mat-dialog-content>
}
@if (data?.submitButtonText || data?.cancelButtonText) {
  <mat-dialog-actions class="d-flex justify-content-between flex-nowrap">
    @if (data?.submitButtonText) {
      <button
        type="button"
        class="btn rounded-1 fs-14 btn-primary fw-bold w-50"
        [disabled]="data.isSubmitDisabled?.() === true"
        (click)="onSubmit()"
      >
        {{ data.submitButtonText }}
      </button>
    }
    @if (data?.cancelButtonText) {
      <button class="btn btn-outline-primary fs-14 rounded-1 fw-bold w-50" (click)="onCancel()">
        {{ data.cancelButtonText }}
      </button>
    }
  </mat-dialog-actions>
}
